export const topbarStyles = {
  appBar: {
    backgroundColor: '#FCF8F2',
    color: '#AE8648',
    boxShadow: 'none',
    borderBottom: '1px solid #EFDCB5',
    position: 'relative'
  },

  toolbar: {
    minHeight: '64px !important',
    height: '64px !important',
    px: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    overflow: 'hidden'
  },

  logo: {
    width: 92,
    height: 'auto',
    display: 'block',
    flexShrink: 0,
    mr: 4
  },

  addPatientButton: {
    height: 38,
    borderRadius: '4px',
    border: '1px solid #E3C796',
    background: '#F5DDAE',
    color: '#424242',
    fontSize: '0.68rem',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    boxShadow: 'none',
    flexShrink: 0,
    gap:0,

    '&:hover': {
      background: '#F0D49B',
      borderColor: '#D9B36A',
      boxShadow: 'none'
    },

    '& .MuiButton-startIcon': {
      mr: 0.5
    }
  },

  searchBox: {
    width:'22%',
    height: 36,
    border: '1px solid #DADADA',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    px: 0.5,
    bgcolor: '#fff',
    flexShrink: 0,
    fontSize:10,
  },

 menuWrapper: {
  display: { xs: 'none', lg: 'flex' },
  alignItems: 'stretch',
  justifyContent: 'end',
  gap: 3,
  px: 0,
  height: '100%'
},

menuItem: isActive => ({
  position: 'relative',
  height: 46,
  minWidth: 70,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0,
  fontSize: 13,
  color: isActive ? '#A8792A' : '#A8792A',
  fontWeight: isActive ? 600 : 500,
  textAlign: 'center',
  fontFamily:'Roboto',
  whiteSpace:'nowrap',

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -9,
    left: '50%',
    transform: 'translateX(-50%)',
    width: isActive ? '100%' : 0,
    height: 2,
    borderRadius: 2,
    backgroundColor: '#A8792A',
    // transition: 'width .25s ease'
  }
}),

menuIconBox: {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 22
},

  dot: {
    width: 5,
    height: 5,
    borderRadius: '50%',
    backgroundColor: '#F44336',
    position: 'absolute',
    top: -5,
    right: -5,
    flexShrink: 0
  },

  dateBox: {
    borderLeft: '1px solid #E3C796',
    pl: 2,
    pr: 1,
    textAlign: 'right',
    flexShrink: 0
  },

  dateText: {
    fontSize: '0.68rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    color: '#757575',
    lineHeight: 1.4
  },

  timeText: {
    fontSize: 11,
    color: '#757575',
    lineHeight: 1.2
  },

  userCircle: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    bgcolor: '#D9A85A',
    color: '#fff',
    fontWeight: 700,
    fontSize: 13,
    fontFamily: 'Roboto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },

  mobileMenu: {
    display: { xs: 'flex', lg: 'none' },
    ml: 'auto'
  },
   menuIconContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    width: 22,
    height: 22,
    lineHeight: 0,
    flexShrink: 0
  },



  notificationDot: {
    position: 'absolute',
    top: 0,
    left: -4,
    width: 5,
    height: 5,
    minWidth: 5,
    borderRadius: '50%',
    backgroundColor: '#F44336',
    pointerEvents: 'none'
  },
};